<template>
    <div class="my-1" >
        <v-carousel :height="height" cycle interval="5000" show-arrows-on-hover hide-delimiter-background
            delimiter-icon="mdi-minus">
            <v-carousel-item v-for="(slide, index) in slides" 
                :key="index"
                :href="slide.link">
                <v-img contain :src="slide.src"></v-img>
            </v-carousel-item>
        </v-carousel>
    </div>
</template>

<script>

export default {
    props: ["slides"],
    computed: {
        height() {
            let height;
             switch (this.$vuetify.breakpoint.name) {
                case 'xs': 
                    height = 160;
                    break;
                case 'sm': 
                    height = 280;
                    break;
                case 'md': 
                    height = 300;
                    break;
                default: 
                    height = 400;
            }
            return height;
        },
    }
}
</script>